
import { CheckoutInputField } from 'components/CheckoutFormControls';
import { cn } from 'lib/utils';

import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Trans, t } from '@lingui/macro';
import { useCheckoutContext } from 'context/CheckoutContext';

const stripeShellClass =
    'rounded-md border border-solid border-[hsl(var(--border))] bg-[hsl(var(--input))] px-3.5 py-[14px] transition-colors focus-within:border-primary/50';

/* Stripe renders inside its own iframe — CSS variables are unreliable. Use explicit colors. */
const STRIPE_TEXT = '#f1f3f5';
const STRIPE_PLACEHOLDER = '#b4bcc8';

const stripeInputStyle = {
    base: {
        fontSize: '16px',
        color: STRIPE_TEXT,
        '::placeholder': { color: STRIPE_PLACEHOLDER },
    },
    empty: {
        fontSize: '16px',
        color: STRIPE_PLACEHOLDER,
    },
};

export default function PaymentForm() {
    const {
        handleFormChange: onFormChange,
        customerForm: values,
        paymentForm: ccState,
    } = useCheckoutContext();

    const { ccName } = values;
    const { ccNumber, cvc, ccExpiry } = ccState;

    function handleFormChange(e) {
        onFormChange(e.target.id, e.target.value);
    }

    return (
        <div className="flex flex-col pb-4">
            <h3 className="mb-1 text-lg font-bold text-foreground">
                <Trans>Payment</Trans>
            </h3>
            <p className="mb-6 text-sm text-muted-foreground">
                <Trans>Your payment is secure and encrypted</Trans>
            </p>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <div className={cn(stripeShellClass, ccNumber.error && 'border-destructive', 'sm:col-span-2')}>
                    <CardNumberElement
                        options={{
                            placeholder: t`Credit Card Number`,
                            style: stripeInputStyle,
                        }}
                    />
                </div>

                <div className={cn(stripeShellClass, ccExpiry.error && 'border-destructive')}>
                    <CardExpiryElement
                        options={{
                            placeholder: t`Expiry (MM/YY)`,
                            style: stripeInputStyle,
                        }}
                    />
                </div>

                <div className={cn(stripeShellClass, cvc.error && 'border-destructive')}>
                    <CardCvcElement
                        options={{
                            placeholder: t`Security Code`,
                            style: stripeInputStyle,
                        }}
                    />
                </div>

                <CheckoutInputField
                    id="ccName"
                    label={<Trans>Name on Card</Trans>}
                    value={ccName.value}
                    error={ccName.error}
                    message={ccName.message}
                    onChange={handleFormChange}
                    className="sm:col-span-2"
                />
            </div>
        </div>
    );
}
